<template>
  <div class="scope-selector">
    <el-radio-group v-model="scopeType" @change="handleScopeTypeChange">
      <el-radio-button label="collection">Entire Course</el-radio-button>
      <el-radio-button label="groups">Selected Groups</el-radio-button>
      <el-radio-button label="knowits">Selected Knowits</el-radio-button>
    </el-radio-group>

    <!-- Group Selection -->
    <div v-if="scopeType === 'groups'" class="selection-panel">
      <el-checkbox-group v-model="selectedGroups" @change="emitChange">
        <div
          v-for="(group, index) in groups"
          :key="index"
          class="selection-item"
        >
          <el-checkbox :label="index">
            <span class="group-name">{{ group.title || `Group ${index + 1}` }}</span>
            <span class="item-count">({{ (group.knowits || []).length }} knowits)</span>
          </el-checkbox>
        </div>
      </el-checkbox-group>
      <div v-if="groups.length === 0" class="empty-hint">
        No groups in this course
      </div>
    </div>

    <!-- Knowit Selection -->
    <div v-if="scopeType === 'knowits'" class="selection-panel">
      <el-tree
        ref="knowitTree"
        :data="treeData"
        show-checkbox
        node-key="id"
        :default-expand-all="true"
        :props="{ label: 'label', children: 'children' }"
        @check="handleKnowitCheck"
      />
      <div v-if="treeData.length === 0" class="empty-hint">
        No content in this course
      </div>
    </div>

    <!-- Selection Summary -->
    <div class="selection-summary" v-if="scopeType !== 'collection'">
      <i class="el-icon-info"></i>
      <span v-if="scopeType === 'groups'">
        {{ selectedGroups.length }} group(s) selected
      </span>
      <span v-else-if="scopeType === 'knowits'">
        {{ selectedKnowits.length }} knowit(s) selected
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestBankScopeSelector',
  props: {
    value: {
      type: Object,
      default: () => ({
        type: 'collection',
        selectedGroups: [],
        selectedKnowits: []
      })
    },
    collectionForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      scopeType: 'collection',
      selectedGroups: [],
      selectedKnowits: []
    }
  },
  computed: {
    groups() {
      return this.collectionForm.groups || []
    },
    treeData() {
      return this.groups.map((group, groupIndex) => ({
        id: `group-${groupIndex}`,
        label: group.title || `Group ${groupIndex + 1}`,
        groupIndex,
        children: (group.knowits || []).map((knowit, knowitIndex) => ({
          id: `knowit-${groupIndex}-${knowitIndex}`,
          label: (knowit.post_info && knowit.post_info.title) || `Knowit ${knowitIndex + 1}`,
          groupIndex,
          knowitIndex,
          isKnowit: true
        }))
      }))
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.scopeType = val.type || 'collection'
          this.selectedGroups = val.selectedGroups || []
          this.selectedKnowits = val.selectedKnowits || []
        }
      }
    }
  },
  methods: {
    handleScopeTypeChange() {
      this.selectedGroups = []
      this.selectedKnowits = []
      if (this.$refs.knowitTree) {
        this.$refs.knowitTree.setCheckedKeys([])
      }
      this.emitChange()
    },

    handleKnowitCheck() {
      const checkedNodes = this.$refs.knowitTree.getCheckedNodes()
      this.selectedKnowits = checkedNodes
        .filter(node => node.isKnowit)
        .map(node => ({
          groupIndex: node.groupIndex,
          knowitIndex: node.knowitIndex
        }))
      this.emitChange()
    },

    emitChange() {
      this.$emit('input', {
        type: this.scopeType,
        selectedGroups: this.selectedGroups,
        selectedKnowits: this.selectedKnowits
      })
    }
  }
}
</script>

<style scoped>
.scope-selector {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.selection-panel {
  max-height: 200px;
  overflow-y: auto;
  padding: 12px;
  background: #fafafa;
  border-radius: 6px;
  border: 1px solid #ebeef5;
}

.selection-item {
  padding: 6px 0;
}

.group-name {
  font-weight: 500;
}

.item-count {
  color: #909399;
  font-size: 12px;
  margin-left: 8px;
}

.empty-hint {
  color: #909399;
  font-size: 13px;
  text-align: center;
  padding: 20px;
}

.selection-summary {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #606266;
}

.selection-summary .el-icon-info {
  color: #409eff;
}
</style>
